import Splide from '@splidejs/splide';

export function testimonialSlider() {
    const $sliders = document.querySelectorAll('.testimonial-slider .splide');

    $sliders?.forEach($slider => {
        new Splide($slider, {
            type: 'loop',
            perPage: 1,
            speed: 500,
            gap: '1.5rem',
            pagination: false,
        }).mount();
    });
}